import RezerwyGetList from './rezerwyGetList'
const data = () => {
    return RezerwyGetList();  
};
export default data;